import React from 'react';
import { makeStyles, Paper, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  bubble: {
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    maxWidth: '100%',
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    transition: 'background-color 0.3s',
  },
  clickedBubble: {
    backgroundColor: theme.palette.action.selected,
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  messageText: {
    wordWrap: 'break-word',
  },
}));

const OptionItem = ({ item, isClicked, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.messageContainer}>
      <Paper
        className={`${classes.bubble} ${isClicked ? classes.clickedBubble : ''}`}
        onClick={onClick}
      >
        <Typography className={classes.messageText}>{item[1]}</Typography>
      </Paper>
    </div>
  );
};

export default OptionItem;
